<template>
  <div class="auth-layout row align-content--center">
    <div class="flex xs12 pa-3 flex-center">
      <div class="py-5 flex-center" to="#">
        <easy-pallet />
      </div>
    </div>

    <div class="flex xs12 pa-3">
      <div class="d-flex justify--center window-login">
        <va-card class="auth-layout__card" >
            <!-- <va-tab>{{ $t('auth.createNewAccount') }}</va-tab> -->

          <div class="pa-3">
            <router-view />
          </div>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
import EasyPallet from '@/components/EasyPallet'

export default {
  name: 'AuthLayout',
  components: { EasyPallet },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
.auth-layout {
  min-height: 100vh;
  // background-image: linear-gradient(to top, #FFFFFF, #f8e9e9);

  &__card {
    width: 100%;
    margin-top: -50px;
    max-width: 500px;
  }

  &__options {
    @include media-breakpoint-down(xs) {
      flex-direction: column;
    }
  }
}

.window-login {
  margin-bottom: 200px;
}
</style>
